// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from "react";
// import Heading from "../Heading";

import Heading from "../../components/Highlightedheading/Heading";
import Pageheading from "../../components/PageHeading/Pageheading";
import { RiHome2Line } from "react-icons/ri";
import texture from "./contactpage/texture.png";
import toast, { Toaster } from "react-hot-toast";
import BasicTextFields from "../../components/textfield/textField";
import Button from "../../components/Buttons/Button";
import "./contactus.css";
import { Link } from "react-router-dom";
import contactImg from "../../assets/contactus/Banner.png";
import mobileContactImg from "../../assets/contactus/Banner_Mobile.png";
import BannerHeading from "../../components/BannerHeading/Heading";
import Joi from "joi";
import axios from "axios";
import config from "../../config/config";

const ContactPage = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [formValues, setFormValues] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [errors, setErrors] = useState({});

  const enquirySchema = Joi.object({
    fullName: Joi.string()
      .pattern(/^[a-zA-Z\s]+$/)
      .required()
      .label("Name"),

    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .label("Email"),

    phoneNumber: Joi.string()
      .length(10)
      .pattern(/^[0-9]+$/)
      .required()
      .label("Contact Number"),

    message: Joi.string().allow("").optional(),
  });

  const validateForm = (values) => {
    const { error } = enquirySchema.validate(values, config.joiOptions);

    if (!error) return {};

    const newErrors = {};

    error.details.forEach((err) => {
      const label = err.context?.label || err.path[0];

      if (err.type === "string.empty" || err.type === "any.required") {
        newErrors[err.path[0]] = `${label} is required`;
      } else {
        newErrors[err.path[0]] = `Enter a valid ${label}`;
      }
    });

    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues({ ...formValues, [name]: value });

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    const validationErrors = validateForm(formValues);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setIsSubmitting(true);
      try {
        await axios.post(`${config.apiUrl}/enquiry-leads`, {
          name: formValues.fullName,
          email: formValues.email,
          phone: formValues.phoneNumber,
          message: formValues.message,
        });

        toast.success("Form submitted successfully!");

        setFormValues({
          fullName: "",
          email: "",
          phoneNumber: "",
          message: "",
        });
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong!");
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // 768px is typically the breakpoint for md in Tailwind
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const preloadImages = [contactImg, mobileContactImg];
    preloadImages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
    <div className="w-full h-full  text-white relative">
      <Toaster position="top-right" />
      <div className="relative w-full  h-[90vh] md:h-[40vw] 3xl:h-[60vh] flex items-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-transparent z-10">
          <div className="md:pl-[5.63vw] pl-4 flex items-center md:pt-[10.09vw] pt-[25vw]">
            <Pageheading pageHeading={"Contact Us"} icon={<RiHome2Line />} />
          </div>
        </div>
        <div
          className="absolute inset-0 bg-contain md:bg-cover bg-no-repeat bg-left md:bg-center flex justify-center items-center"
          style={{
            backgroundImage: `url(${isMobile ? mobileContactImg : contactImg})`,
          }}
        >
          <div className="absolute top-[25vh] md:top-[20vw] md:left-[17.47vw] flex justify-start items-center z-10">
            <BannerHeading headingText={"Contact Us"} />
          </div>
        </div>
        <div className="absolute h-[250px] md:h-[300px] tab:h-[327px] w-full top-0 bg-gradient-to-b from-[#121614]"></div>
      </div>

      <div className=" grid grid-cols-1 md:grid-cols-2 gap-8 relative w-full px-4 md:pl-[7.95vw] md:py-[4.69vw] ">
        <div className=" flex flex-col">
          <h2
            data-aos="fade-up"
            className="font-montserrat uppercase font-medium md:text-[1.88vw] text-[5.87vw] text-white  md:w-[30.42vw]  pt-[5.56vh] "
          >
            <span>PLEASE BE FREE TO </span>
            <br />
            <span>CONTACT US USING THE FORM </span>
            <br className="hidden md:block" />
            <span className="">BELOW OR EMAIL DIRECTLY:</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2   md:gap-x-[6.35vw] gap-y-[3.70vh] pt-[3.70vh] md:gap-y-[7.41vh] md:pt-[8.15vh] md:text-[1.25vw] text-[5.33vw] brightness-90 font-montserrat font-light">
            <div data-aos="fade-up">
              <p className="flex items-center md:space-x-[0.833vw] space-x-[6.4vw]">
                <span className="md:w-[2.29vw] w-[10vw] ">
                  <img
                    src="/Contactpage/maillogo.png"
                    className="w-full h-full object-cover brightness-150"
                    alt=""
                  />
                </span>
                <span className="">Ashutosh:</span>
              </p>
              <a
                href="mailto:ashutosh@ratfilms.in"
                className="hover:underline md:pl-[3.20vw] pl-[16.5vw]"
              >
                ashutosh@ratfilms.in
              </a>
            </div>
            <div data-aos="fade-up">
              <p className="flex items-center md:space-x-[0.833vw] space-x-[6.4vw]">
                <span className="md:w-[2.29vw] w-[10vw] ">
                  <img
                    src="/Contactpage/maillogo.png"
                    className="w-full h-full object-cover brightness-150"
                    alt=""
                  />
                </span>
                <span className="">Ruchi:</span>
              </p>
              <a
                href="mailto:ruchi@ratfilms.in"
                className="hover:underline md:pl-[3.20vw] pl-[16.5vw]"
              >
                ruchi@ratfilms.in
              </a>
            </div>
            <div data-aos="fade-up">
              <p className="flex items-center md:space-x-[0.833vw] space-x-[6.4vw] whitespace-nowrap">
                <span className="md:w-[2.29vw] w-[10vw]">
                  <img
                    src="/Contactpage/maillogo.png"
                    className="w-full h-full object-cover brightness-150"
                    alt=""
                  />
                </span>
                <span className="">Information Desk:</span>
              </p>
              <a
                href="mailto:info@ratfilms.in"
                className="hover:underline md:pl-[3.20vw] pl-[16.5vw]"
              >
                info@ratfilms.in
              </a>
            </div>
            <div data-aos="fade-up">
              <p className="flex items-center md:space-x-[0.833vw] space-x-[6.4vw]">
                <span className="md:w-[2.29vw] w-[10vw]">
                  <img
                    src="/Contactpage/maillogo.png"
                    className="w-full h-full object-cover brightness-150"
                    alt=""
                  />
                </span>
                <span className="whitespace-nowrap">Taher:</span>
              </p>
              <a
                href="mailto:taher@ratfilms.in"
                className="hover:underline md:pl-[3.20vw] pl-[16.5vw]"
              >
                taher@ratfilms.in
              </a>
            </div>
            <div data-aos="fade-up">
              <p className="flex items-center md:space-x-[0.833vw] space-x-[6.4vw] whitespace-nowrap">
                <span className="md:w-[2.29vw] w-[10vw]">
                  <img
                    src="/Contactpage/maillogo.png"
                    className="w-full h-full object-cover brightness-150"
                    alt=""
                  />
                </span>
                <span className="">Accounts Department:</span>
              </p>
              <a
                href="mailto:accounts@ratfilms.in"
                className="hover:underline md:pl-[3.20vw] pl-[16.5vw]"
              >
                accounts@ratfilms.in
              </a>
            </div>
          </div>
          <div className=" border-[1px] opacity-[15%] border-[#ffff] md:w-[50%] w-full md:my-[7.41vh] my-[3.70vh]"></div>
          <div className="flex flex-col md:flex-row items-start md:gap-x-[6.35vw] gap-y-[3.70vh] md:gap-y-0 justify-between brightness-90  font-montserrat font-light md:text-[1.25vw]  text-[5.33vw]">
            <div data-aos="fade-up">
              <p className="flex items-start md:space-x-[0.833vw] space-x-[6.4vw]">
                <span className="md:w-[2.29vw] w-[10vw]">
                  <img
                    src="/Contactpage/phone.png"
                    className="w-full h-full object-cover brightness-150"
                    alt=""
                  />
                </span>
                <span className="">Telephone directly via </span>
              </p>
              <a
                href="tel:9029500400"
                className="hover:underline md:pl-[3.20vw] pl-[16.5vw]"
              >
                9029500400
              </a>
            </div>
            <div data-aos="fade-up">
              <p className="flex items-start  md:space-x-[0.833vw] space-x-[6.4vw] ">
                <span className="md:w-[2.29vw] w-[32.29vw]">
                  <img
                    src="/Contactpage/location.png"
                    className="w-full h-full object-cover brightness-150"
                    alt=""
                  />
                </span>
                <a
                  href="https://maps.app.goo.gl/xmPPZtA8945SwngJA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="md:w-[16.72vw] cursor-pointer md:pl-0">
                    305, Suvaas apartment, 15th Rd, Vithaldas Nagar, Santacruz
                    (West), Mumbai, Maharashtra 400054.
                  </div>
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:items-end items-start md:pr-[5.68vw] md:gap-y-[6.11vh]">
          <Link
            to="https://maps.app.goo.gl/xmPPZtA8945SwngJA"
            target="_blank"
            rel="noopener noreferrer"
            className="font-montserrat uppercase  hover:underline text-[5.33vw] pt-[5vh] font-light md:hidden block"
            data-aos="fade-up"
          >
            Get Direction
          </Link>
          <div
            className="flex md:flex-row items-end flex-row-reverse md:space-x-[0.833vw] gap-x-[3.4vw] md:gap-x-0  py-[3.77vh] md:py-0 cursor-pointer relative"
            onClick={() => setIsHovered(true)}
          >
            {/* Mail Icon with Smooth Animation */}
            <a
              href="mailto:example@example.com"
              className={`md:w-[2.97vw] w-[10vw] ${
                isHovered
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 translate-x-8"
              } transform transition-transform transition-opacity duration-[1.5s] ease-in-out`}
            >
              <img src="/Contactpage/mail.png" alt="mail" />
            </a>

            {/* Link Icon with Smooth Animation */}
            <a
              href="https://example.com"
              className={`md:w-[2.97vw] w-[10vw] ${
                isHovered
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 translate-x-8"
              } transform transition-transform  duration-[1.5s] ease-in-out`}
            >
              <img src="/Contactpage/link.png" alt="link" />
            </a>

            {/* Share Icon and Text */}
            <div className=" flex items-center">
              <span className="md:w-[2.97vw] w-[10vw]">
                <img
                  src="/Contactpage/share.png"
                  alt="share"
                  className="w-full h-full object-cover"
                />
              </span>
              <span
                className={`${
                  isHovered ? "opacity-100" : "opacity-0"
                } transition-opacity duration-700 font-montserrat font-light md:text-[0.9375vw] md:pl-3 pl-1 md:mr-3 `}
              >
                Share
              </span>
            </div>
          </div>

          <div
            data-aos="fade-up"
            className="hidden md:flex mt-8 ml-2 aspect-square items-center justify-center w-full shadowanimation2"
          >
            <div className="w-full h-full shadowanimation1">
              <div className="w-full h-full shadowanimation">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3584.12367850822!2d72.82954887497735!3d19.07716498212767!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c90bb6b3a01d%3A0x1072ccda9959e48a!2sR.A.T%20films!5e1!3m2!1sen!2sin!4v1751864286517!5m2!1sen!2sin"
                  // width="600"
                  // height="450"
                  width="100%"
                  height="100%"
                  className="w-full h-full"
                  style={{ marginRight: 0, border: 0 }}
                  // style="border:0;"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="relative flex flex-col w-full bg-glass/30 backdrop-blur-3xl"
        // style={{
        //   backgroundImage: `url(${texture})`,
        //   backgroundPosition: "0% 0%",
        //   backgroundSize: "cover",
        // }}
      >
        <div className="rounded-lg w-full h-full flex flex-col font-montserrat font-light text-white relative">
          <div className="inner-scratch">
            <div className=" md:px-[7.29vw] px-4 ">
              <h2
                data-aos="fade-up"
                className="md:py-[8vh] py-[3.70vh] text-[40px] leading-[40px] sm:text-[80px] sm:leading-[80px] 3xl-plus:text-[94px] 3xl-plus:leading-[94px] font-bebas_neue tracking-normal uppercase brightness-125  text-transparent text-center bg-clip-text bg-text-gradient"
              >
                ENQUIRE NOW
              </h2>

              <form
                onSubmit={handleSubmit}
                className="space-y-6 md:space-y-16 md:pb-[8vh] pb-[3.70vh]"
                data-aos="fade-up"
              >
                <div className="flex flex-col space-y-6 md:flex-row text-[16px] md:text-[1.25vw] justify-between items-center md:gap-10 md:space-y-0 md:space-x-4">
                  <div className="w-full relative">
                    <BasicTextFields
                      name="fullName"
                      value={formValues.fullName}
                      onChange={handleChange}
                      text="Name*"
                    />
                    {errors.fullName && (
                      <p className="text-red-500 text-[3.5vw] md:text-[1.1vw] p-1 absolute bottom-0 translate-y-[100%]">
                        {errors.fullName}
                      </p>
                    )}
                  </div>
                  <div className="w-full relative">
                    <BasicTextFields
                      name="email"
                      value={formValues.email}
                      onChange={handleChange}
                      text="Email Id*"
                    />
                    {errors.email && (
                      <p className="text-red-500 text-[3.5vw] md:text-[1.1vw] p-1 absolute bottom-0 translate-y-[100%]">
                        {errors.email}
                      </p>
                    )}
                  </div>
                  <div className="w-full relative">
                    <BasicTextFields
                      name="phoneNumber"
                      value={formValues.phoneNumber}
                      onChange={handleChange}
                      text="Contact No*"
                      inputModeNumeric={true}
                    />
                    {errors.phoneNumber && (
                      <p className="text-red-500 text-[3.5vw] md:text-[1.1vw] p-1 absolute bottom-0 translate-y-[100%]">
                        {errors.phoneNumber}
                      </p>
                    )}
                  </div>
                </div>
                <div className="flex flex-col space-y-6 md:flex-row md:space-y-0 md:space-x-28">
                  <div className="w-full space-y-6 relative">
                    <BasicTextFields
                      name="message"
                      value={formValues.message}
                      onChange={handleChange}
                      text="Message"
                      fullWidth={true}
                    />
                    {/* {errors.message && (
              <p className="text-red-500 text-md p-1 absolute bottom-0 translate-y-[100%]">{errors.message}</p>
            )} */}
                  </div>
                  <Button
                    // buttonText={"Submit"}
                    buttonText={isSubmitting ? "Submitting..." : "Submit"}
                    // customCss={"md:pt-2 pt-[3.7vh] md:py-0"}
                    customCss={"md:pt-2 pt-[2vh] md:py-0"}
                    disabled={isSubmitting}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
